import { axios, Response } from '..'
import { PersonaInfoSummary } from '../gallery/get-folder-share-options'

export default async function therapistInfo(): Response<PersonaInfoSummary[]> {
  return await axios.get('/v1/therapists/info')
}
